"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_Subscription_Channel = exports.Subscription_ChannelTypeKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_url_1 = require("../Scalar/RTTI_url");
var RTTI_code_1 = require("../Scalar/RTTI_code");
var Subscription_ChannelTypeKind;
(function (Subscription_ChannelTypeKind) {
    Subscription_ChannelTypeKind["_restHook"] = "rest-hook";
    Subscription_ChannelTypeKind["_websocket"] = "websocket";
    Subscription_ChannelTypeKind["_email"] = "email";
    Subscription_ChannelTypeKind["_sms"] = "sms";
    Subscription_ChannelTypeKind["_message"] = "message";
})(Subscription_ChannelTypeKind = exports.Subscription_ChannelTypeKind || (exports.Subscription_ChannelTypeKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_Subscription_Channel = t.recursion('ISubscription_Channel', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        type: (0, EnumType_1.createEnumType)(Subscription_ChannelTypeKind, 'Subscription_ChannelTypeKind'),
        _type: RTTI_Element_1.RTTI_Element,
        endpoint: RTTI_url_1.RTTI_url,
        _endpoint: RTTI_Element_1.RTTI_Element,
        payload: RTTI_code_1.RTTI_code,
        _payload: RTTI_Element_1.RTTI_Element,
        header: t.array(t.string),
        _header: t.array(RTTI_Element_1.RTTI_Element)
    });
});
//# sourceMappingURL=RTTI_Subscription_Channel.js.map